import React, {useEffect, useState} from 'react';
import Icons from "../../public/assets/svg";
import styles from "../../styles/components/pagination.module.scss";
const index = (props) => {

const [allPages, setAllPages] =   useState([])
const [first, setFirst] = useState(1)
const [second, setSecond] = useState(2)
const [forward, setForward] = useState(true)
const [backward, setBackward] = useState(false)


   React.useEffect(() => {
       let pages = []
       //console.log(props.totalLength, "totalLength kitni hai")
       for (let i=1; i<= Math.ceil(props.totalLength/5); i++) {
        pages.push(i)
       }
       //console.log(pages)
       setAllPages([...pages])

       if (props.paginationNum ==1) {
           setFirst(1)
           setSecond(2)
           setBackward(false)
           setForward(true)
       }
   }, [props.totalLength])



   const pageNumClicked = (pageNum) =>  {
      
      
        props.setPaginationNum(pageNum)
      if(  pageNum == Math.ceil(props.totalLength/5)) {
          setForward(false)
          setBackward(true)
          setFirst(pageNum-1)
          setSecond(pageNum)
          
      }
      else if (pageNum == 1) {
          setBackward(false)
          setForward(true)
          setFirst(1)
          setSecond(2)
      }
       
      
   }

   const nextPage = () => {
       if (props.paginationNum< Math.ceil(props.totalLength/5)){
           if (props.paginationNum == 2) {
               setBackward(true)
           }

        if (props.paginationNum >=  Math.ceil(props.totalLength/5)-2){
            setForward(false)
        //    setFirst(1)
         //   setSecond(Math.ceil(props.totalLength/5)-1)
           
        }
        else {    
        setForward(true)    
        }

        if (props.paginationNum == second){
            setFirst(props.paginationNum+1)
        setSecond(props.paginationNum+2)

        
        
        }
        props.setPaginationNum(props.paginationNum+1)
       }
      
   }


   const previousPage = () => {


    if (props.paginationNum > 1) {



        
    if (props.paginationNum == Math.ceil(props.totalLength/5)-1) {
        setForward(true)
    }

        if (props.paginationNum <= 3) {
            setBackward(false)
        }
        else {
            setBackward(true)
        }

      

    
    // if (second ==  Math.ceil(props.totalLength/5)-2){
    //     setForward(false)
    //     setFirst(1)
    //     setSecond(Math.ceil(props.totalLength/5)-1)
    //     props.setPaginationNum(props.paginationNum-1)
    // }

    if (props.paginationNum != 1){
       
        if (props.paginationNum == first){
            setFirst(props.paginationNum-2)
        setSecond(props.paginationNum-1)

        }
        
    }
    props.setPaginationNum(props.paginationNum-1)
}
   
   }

    return (
        <>
            <div className={styles.paginationOuter}>
                <div className={styles.leftArrow} onClick = {previousPage}>
                    <img src="/assets/svg/paginationarrow.png" />
                </div>
                <div className={styles.main}>
                    {  allPages.map((item, index) =>  {
                         
                         if (item == 1 || item == allPages[allPages.length-1]){
                            return(
                                <>
                                {forward && item == allPages[allPages.length-1] && props.totalLength > 10 ? <span>    .    .    .</span>: null}
                                <span className={`${styles.number} ${props.paginationNum==item ?styles.active : null }` } key={index} onClick = {() => pageNumClicked(item)}>{item}</span>
                                {backward && item == 1 && props.totalLength > 10 ? <span>    .    .    .</span>: null }
                                </>
                                )

                         }
                        
                        
                        else if(item == first || item == second)  {
                            
                            return (
                            <>
                            <span className={`${styles.number} ${props.paginationNum==item ?styles.active : null }` } key={index} onClick = {() => pageNumClicked(item)}>{item}</span>
                            </>
                            )
                        }
                       


                    })  }
                   
                </div>
                <div className={styles.rightArrow} onClick = {nextPage}>
                    <img src="/assets/svg/paginationarrow.png" />
                </div>
            </div>
        </>
    )
}

export default index
